import React from 'react';
import { Mail, MessageSquare } from 'lucide-react';

export default function ContactUs() {
    return (
        <div className="animate-fade-in" style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '40px 20px',
            paddingBottom: '100px',
            color: 'var(--text-main)'
        }}>
            <div className="glass-panel" style={{ padding: '50px', textAlign: 'center' }}>
                <div style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px'
                }}>
                    {/* Mascot */}
                    <img
                        src="/images/mascots/BitHack.png"
                        alt="BitHack Mascot"
                        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                        }}
                    />
                    {/* Fallback Icon */}
                    <div style={{ display: 'none' }}>
                        <Mail size={40} color="#10b981" />
                    </div>
                </div>

                <h1 style={{ marginBottom: '10px' }}>Contact Us</h1>
                <p style={{ opacity: 0.7, marginBottom: '40px', maxWidth: '400px', margin: '0 auto 40px' }}>
                    Have questions, feedback, or business inquiries? We'd love to hear from you.
                </p>

                <div style={{
                    background: 'rgba(0,0,0,0.3)',
                    padding: '20px',
                    borderRadius: '12px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '15px',
                    border: '1px solid rgba(255,255,255,0.1)'
                }}>
                    <Mail size={24} color="#10b981" />
                    <div style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: '12px', opacity: 0.5, textTransform: 'uppercase', letterSpacing: '1px' }}>Email Us At</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>support@sparkinspo.org</div>
                    </div>
                </div>

                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', opacity: 0.6 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MessageSquare size={16} />
                        <span>Support usually responds within 24 hours</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
